
import * as React from 'react';
import { getLoggedInBruger } from '../../infrastructure/Security';
import { BrugerRolleEnum } from '../../models/enums/BrugerRolleEnum';
import KonkurrenceListAdmin from './KonkurrenceListAdmin';
import KonkurrenceListLaererEkstern from './KonkurrenceListLaererEkstern';

interface KonkurrenceListProps {
}

class KonkurrenceList extends React.Component<KonkurrenceListProps, {}> {
    constructor(props: KonkurrenceListProps) {
        super(props);
    }

    render() {
        const rolle = getLoggedInBruger().rolle;
        if (rolle === BrugerRolleEnum.Administrator) {
            return <KonkurrenceListAdmin />;
        } else if (rolle === BrugerRolleEnum.Laerer || rolle === BrugerRolleEnum.Ekstern) {
            return <KonkurrenceListLaererEkstern />;
        }
        return <div />;
    }
}

export default KonkurrenceList;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/konkurrence/KonkurrenceList.tsx